'use client'
import { useEffect } from 'react'

import { useNotification } from '@/providers/notification'

const ClearSession = () => {
  const { logOut, initialized } = useNotification()
  useEffect(() => {
    if (initialized) {
      logOut()
    }
    localStorage.clear()
  }, [logOut, initialized])
  return <></>
}

export default ClearSession
